import {Row, Col} from "reactstrap";
import {useUser} from "../../contexts/AuthContext";
import SearchItem from "./SearchItem";

const SearchCollection = (props: any) => {
  const {user} = useUser();

  const timezoneOffsetMinutes: number = user.settings.timezoneOffsetMinutes;

  if (props === undefined || !props.items || !props.items.length) {
    return (
      <>
        <h4>No results</h4>
      </>
    );
  }

  let items: any[] = [];

  // get the item with the highest fps
  let scaleFactor: number = Math.max.apply(
    Math,
    props.items.map(function (o: any) {
      return o.MaxFps;
    })
  );

  let counter: number = 1;
  for (const item of props.items) {
    items.push(
      <SearchItem
        {...item}
        index={counter}
        scaleFactor={scaleFactor}
        key={`i-${counter}`}
        rank={counter}
        timezoneOffsetMinutes={timezoneOffsetMinutes}
        {...props}
      />
    );
    counter += 1;
  }

  return (
    <>
      <Row>
        <Col lg="12" md="12">
          {items}
        </Col>
      </Row>
    </>
  );
};

export default SearchCollection;
